export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, 'ociDropdowns', {value: this});
  },
  ociLostLeadReactivatedReasons: [
    {id: 'Rate Drop', name: 'Rate Drop'},
    {id: 'Promotion', name: 'Promotion'},
    {id: 'Changed Mind', name: 'Changed Mind'},
    {id: 'Better Suited Product', name: 'Better Suited Product'},
    {id: 'Other', name: 'Other'},
  ],
  ociActivityQuestions:[
    {id: 'eligibility', name: 'Eligibility'},
    {id: 'product', name: 'Product'},
    {id: 'oci', name: 'OCI'},
    {id: 'project', name: 'Project'},
    {id: 'Other', name: 'Other'},
  ],
  ociLostLeadReasons: [
    {id: 'Credit Score', name: 'Credit Score'},
    {id: 'Down Payment', name: 'Down Payment'},
    {id: 'Foreign', name: 'Foreign'},
    {id: 'Rate', name: 'Rate'},
    {id: 'Micro-unit', name: 'Micro-unit'},
    {id: 'Terms & Conditions', name: 'Terms & Conditions'},
    {id: 'Multi-doors', name: 'Multi-doors'},
    {id: 'OCI Brand Recognition', name: 'OCI Brand Recognition'},
    {id: 'All Cash Condo Purchaser', name: 'All Cash Condo Purchaser'},
    {id: 'Interim Occupancy Ending', name: 'Interim Occupancy Ending'},
    {id: 'Client Not Interested', name: 'Client Not Interested'},
    {id: 'No Response Contacted Multiple Times', name: 'No Response Contacted Multiple Times'},
    {id: 'Bad Contact Info', name: 'Bad Contact Info'},
    {id: 'Unsubscribed', name: 'Unsubscribed'},
    {id: 'Other', name: 'Other'}

  ],
  // don't use ociProjects.. go to the DB for this as the list will change frequently
  ociProjects:[
    {id: "", name: ""},
    {id: "Eau Du Soleil", name: "Eau Du Soleil"},
    {id: "Empire", name: "Empire"},
    {id: "Masey", name: "Masey"},
  ],
  ociResponseType:[
    {id: 'Pending', name: 'Pending'},
    {id: 'Accepted', name: 'Accepted'},
    {id: 'Declined', name: 'Declined'},
  ],
  ociConsentType:[
    {id: 0, name: ''},
    {id: 6, name: 'override'},
    {id: 5, name: 'submitted form'},
  ],
  ociCampaignType:[
    {id: 'wealthsaver', name: 'wealth saver'},
    {id: 'nps', name: 'nps'},
    {id: 'preauth', name: 'pre-auth'},
  ],
  ociApplicantStatus: [
    {id: 'all', name: 'all'},
    {id: 'prospect', name: 'prospect'},
    {id: 'approval', name: 'approval'},
    {id: 'exploration', name: 'exploration'},
    {id: 'awareness', name: 'awareness'},
    {id: 'funding', name: 'funding'},
    {id: 'oneClosed', name: 'oneClosed'},
    {id: 'lostLead', name: 'Lost Lead'},
    {id: 'new', name: 'new'},
    {id: 'invalid', name: 'invalid'}
  ],
  ociDealStatus: [
    {id: 'prospect', name: 'Prospect'},
    {id: 'purchaserApp', name: 'Purchaser App'},
    {id: 'mtgAppEntry', name: 'Mtg App Entry'},
    {id: 'readyToSubmit', name: 'Ready To Submit'},
    {id: 'submittedToLender', name: 'Submitted to Lender'},
    {id: 'lenderApproved', name: 'Lender Approved'},
    {id: 'lenderDeclined', name: 'Lender Declined'},
    {id: 'accepted', name: 'Accepted'},
    {id: 'declined', name: 'Declined'},
    {id: 'conditions', name: 'Conditions'},
    {id: 'dealComplete', name: 'Deal Complete'},
    {id: 'oneClosed', name: 'OneClosed'},
    {id: 'invoiced', name: 'Invoiced'},
    {id: 'paid', name: 'Paid'},
    {id: 'lostLead', name: 'Lost Lead'}
  ],
  ociProjectStatus: [
    {id: 'new', name: 'new'},
    {id: 'uploaded', name: 'uploaded'},
    {id: 'campaign', name: 'campaign'},
    {id: 'funded', name: 'funded'},
    {id: 'suspended', name: 'suspended'}
  ],
  ociLanguagePreference: [
    {id: '', name: ''},
    {id: 'english', name: 'English'},
    {id: 'french', name: 'French'}
  ],
  ociToBeSold: [
    {id: null, name: ''},
    {id: true, name: 'Yes'},
    {id: false, name: 'No'}
  ],
  ociApplicantType: [
    {id: 'applicant', name: 'Applicant'},
    {id: 'coApplicant', name: 'Co-applicant'},
    {id: 'guarantor', name: 'Guarantor'},

  ],
  ociAddNewApplicantType: [
    {id: '', name: ''},
    {id: 'coApplicant', name: 'Co-applicant'},
    {id: 'guarantor', name: 'Guarantor'},
  ],
  ociDwellingType: [
    {id: '', name: ''},
    {id: 'Condo', name: 'Condo'},
    {id: 'Townhome(Row)', name: 'Townhome(Row)'},
  ],
  ociPropertyType: [
    {id: '', name: ''},
    {id: 'Detached', name: 'Detached'},
    {id: 'Semi - Detached', name: 'Semi - Detached'},
    {id: 'Duplex - Detached', name: 'Duplex - Detached'},
    {id: 'Apartment Low Rise', name: 'Apartment Low Rise'},
    {id: 'Apartment High Rise', name: 'Apartment High Rise'},
    {id: 'Mobile', name: 'Mobile'},
    {id: 'Tri Plex - Detached', name: 'Tri Plex - Detached'},
    {id: 'Tri Plex - Semi-Detached', name: 'Tri Plex - Semi-Detached'},
    {id: 'Stacked', name: 'Stacked'},
    {id: 'Modular Home - Detached', name: 'Modular Home - Detached'},
    {id: 'Modular Home - Semi-Detached', name: 'Modular Home - Semi-Detached'},
    {id: 'Four Plex - Detached', name: 'Four Plex - Detached'},
    {id: 'Four Plex - Semi-Detached', name: 'Four Plex - Semi-Detached'},
    {id: 'Condo', name: 'Condo'},
    {id: 'Plot', name: 'Plot'},
    {id: 'Townhome(Row)', name: 'Townhome(Row)'},
  ],
  ociConstructionType: [
    {id: '', name: ''},
    {id: 'new', name: 'New'},
    {id: 'existing', name: 'Existing'},
  ],
  ociUnitType: [
    {id: '', name: ''},
    {id: '1BDRM', name: '1BDRM'},
    {id: '2BDRM', name: '2BDRM'},
    {id: '3BDRM', name: '3BDRM'},
    {id: 'studio', name: 'studio'},
  ],
  ociWaterType: [
    {id: '', name: ''},
    {id: 'municipal', name: 'Municipal'},
    {id: 'well', name: 'Well'},
  ],
  ociSewageType: [
    {id: '', name: ''},
    {id: 'municipal', name: 'Municipal'},
    {id: 'well', name: 'Well'},
  ],
  ociGarageType: [
    {id: '', name: ''},
    {id: 'attached', name: 'Attached'},
    {id: 'detached', name: 'Detached'},
  ],
  ociGarageSize: [
    {id: '', name: ''},
    {id: 'N/A', name: 'N/A'},
    {id: 'single', name: 'single'},
    {id: 'double', name: 'double'},
    {id: 'triple', name: 'triple'},
  ],
  ociRepaymentType: [
    {id: '', name: ''},
    {id: 'principal + interest', name: 'Principal + Interest'},
    {id: 'interest only', name: 'Interest Only'},
  ],
  ociLoanType: [
    {id: '', name: ''},
    {id: 'mortgage', name: 'Mortgage'},
    {id: 'loc', name: 'LOC'},
  ],
  ociHeatingType: [
    {id: '', name: ''},
    {id: 'Electric Baseboard', name: 'Electric Baseboard'},
    {id: 'Forced Air/Gas/Oil/Electric', name: 'Forced Air/Gas/Oil/Electric'},
    {id: 'Hot Water Heating', name: 'Hot Water Heating'},
    {id: 'Other', name: 'Other'},
  ],

  ociDwellingStyle: [
    {id: '', name: ''},
    {id: 'One storey', name: 'One storey'},
    {id: 'Bi-level', name: 'Bi-level'},
    {id: 'Two storey', name: 'Two storey'},
    {id: 'Split level', name: 'Split level'},
    {id: 'Story and a half', name: 'Story and a half'},
    {id: 'Three storey', name: 'Three storey'},
    {id: 'High Rise', name: 'High Rise'}

  ],
  ociOccupancy: [
    {id: '', name: ''},
    {id: 'Owner Occupied', name: 'Owner Occupied'},
    {id: 'Rental', name: 'Rental'}
  ],
  ociDirection: [
    {id: '', name: ''},
    {id: 'N', name: 'N'},
    {id: 'S', name: 'S'},
    {id: 'W', name: 'W'},
    {id: 'E', name: 'E'},
    {id: 'NW', name: 'NW'},
    {id: 'SW', name: 'SW'},
    {id: 'NE', name: 'NE'},
    {id: 'NW', name: 'NW'},
  ],
  ociStreetType: [
    {id: '', name: ''},
    {id: 'ABBEY', name: 'ABBEY'},
    {id: 'ACRES', name: 'ACRES'},
    {id: 'ALLEE', name: 'ALLEE'},
    {id: 'ALLEY', name: 'ALLEY'},
    {id: 'AUT', name: 'AUT'},
    {id: 'AV', name: 'AV'},
    {id: 'AVE', name: 'AVE'},
    {id: 'BAY', name: 'BAY'},
    {id: 'BEACH', name: 'BEACH'},
    {id: 'BEND', name: 'BEND'},
    {id: 'BLVD', name: 'BLVD'},
    {id: 'BOUL', name: 'BOUL'},
    {id: 'BOURNE', name: 'BOURNE'},
    {id: 'BYPASS', name: 'BYPASS'},
    {id: 'BYWAY', name: 'BYWAY'},
    {id: 'C', name: 'C'},
    {id: 'CAMPUS', name: 'CAMPUS'},
    {id: 'CAPE', name: 'CAPE'},
    {id: 'CAR', name: 'CAR'},
    {id: 'CARREF', name: 'CARREF'},
    {id: 'CDS', name: 'CDS'},
    {id: 'CERCLE', name: 'CERCLE'},
    {id: 'CH', name: 'CH'},
    {id: 'CHASE', name: 'CHASE'},
    {id: 'CIR', name: 'CIR'},
    {id: 'CIRCT', name: 'CIRCT'},
    {id: 'CLOSE', name: 'CLOSE'},
    {id: 'COMMON', name: 'COMMON'},
    {id: 'CONC', name: 'CONC'},
    {id: 'COTE', name: 'COTE'},
    {id: 'COUR', name: 'COUR'},
    {id: 'COVE', name: 'COVE'},
    {id: 'CRES', name: 'CRES'},
    {id: 'CRNRS', name: 'CRNRS'},
    {id: 'CROIS', name: 'CROIS'},
    {id: 'CROSS', name: 'CROSS'},
    {id: 'CRT', name: 'CRT'},
    {id: 'CTR', name: 'CTR'},
    {id: 'DALE', name: 'DALE'},
    {id: 'DELL', name: 'DELL'},
    {id: 'DIVERS', name: 'DIVERS'},
    {id: 'DOWNS', name: 'DOWNS'},
    {id: 'DR', name: 'DR'},
    {id: 'ECH', name: 'ECH'},
    {id: 'END', name: 'END'},
    {id: 'ESPL', name: 'ESPL'},
    {id: 'ESTATE', name: 'ESTATE'},
    {id: 'EXPY', name: 'EXPY'},
    {id: 'EXTEN', name: 'EXTEN'},
    {id: 'FARM', name: 'FARM'},
    {id: 'FIELD', name: 'FIELD'},
    {id: 'FOREST', name: 'FOREST'},
    {id: 'FRONT', name: 'FRONT'},
    {id: 'FWY', name: 'FWY'},
    {id: 'GATE', name: 'GATE'},
    {id: 'GDNS', name: 'GDNS'},
    {id: 'GLADE', name: 'GLADE'},
    {id: 'GLEN', name: 'GLEN'},
    {id: 'GREEN', name: 'GREEN'},
    {id: 'GRNDS', name: 'GRNDS'},
    {id: 'GROVE', name: 'GROVE'},
    {id: 'HARBR', name: 'HARBR'},
    {id: 'HGLNDS', name: 'HGLNDS'},
    {id: 'HILL', name: 'HILL'},
    {id: 'HOLLOW', name: 'HOLLOW'},
    {id: 'HTS', name: 'HTS'},
    {id: 'HWY', name: 'HWY'},
    {id: 'ILE', name: 'ILE'},
    {id: 'IMP', name: 'IMP'},
    {id: 'ISLAND', name: 'ISLAND'},
    {id: 'KEY', name: 'KEY'},
    {id: 'KNOLL', name: 'KNOLL'},
    {id: 'LANDNG', name: 'LANDNG'},
    {id: 'LANE', name: 'LANE'},
    {id: 'LINE', name: 'LINE'},
    {id: 'LINK', name: 'LINK'},
    {id: 'LKOUT', name: 'LKOUT'},
    {id: 'LMTS', name: 'LMTS'},
    {id: 'LOOP', name: 'LOOP'},
    {id: 'MALL', name: 'MALL'},
    {id: 'MANOR', name: 'MANOR'},
    {id: 'MAZE', name: 'MAZE'},
    {id: 'MEADOW', name: 'MEADOW'},
    {id: 'MEWS', name: 'MEWS'},
    {id: 'MONTEE', name: 'MONTEE'},
    {id: 'MOOR', name: 'MOOR'},
    {id: 'MOUNT', name: 'MOUNT'},
    {id: 'MTN', name: 'MTN'},
    {id: 'ORCH', name: 'ORCH'},
    {id: 'PARADE', name: 'PARADE'},
    {id: 'PARC', name: 'PARC'},
    {id: 'PASS', name: 'PASS'},
    {id: 'PATH', name: 'PATH'},
    {id: 'PINES', name: 'PINES'},
    {id: 'PK', name: 'PK'},
    {id: 'PKY', name: 'PKY'},
    {id: 'PL', name: 'PL'},
    {id: 'PLACE', name: 'PLACE'},
    {id: 'PLAT', name: 'PLAT'},
    {id: 'PLAZA', name: 'PLAZA'},
    {id: 'PORT', name: 'PORT'},
    {id: 'PROM', name: 'PROM'},
    {id: 'PT', name: 'PT'},
    {id: 'PTWAY', name: 'PTWAY'},
    {id: 'PVT', name: 'PVT'},
    {id: 'QUAY', name: 'QUAY'},
    {id: 'RANG', name: 'RANG'},
    {id: 'RD', name: 'RD'},
    {id: 'RDPT', name: 'RDPT'},
    {id: 'RG', name: 'RG'},
    {id: 'RIDGE', name: 'RIDGE'},
    {id: 'RISE', name: 'RISE'},
    {id: 'RLE', name: 'RLE'},
    {id: 'ROW', name: 'ROW'},
    {id: 'RTE', name: 'RTE'},
    {id: 'RUE', name: 'RUE'},
    {id: 'RUN', name: 'RUN'},
    {id: 'SENT', name: 'SENT'},
    {id: 'SQ', name: 'SQ'},
    {id: 'ST', name: 'ST'},
    {id: 'SUBDIV', name: 'SUBDIV'},
    {id: 'TERR', name: 'TERR'},
    {id: 'THICK', name: 'THICK'},
    {id: 'TLINE', name: 'TLINE'},
    {id: 'TOWERS', name: 'TOWERS'},
    {id: 'TRAIL', name: 'TRAIL'},
    {id: 'TRNABI', name: 'TRNABT'},
    {id: 'TSSE', name: 'TSSE'},
    {id: 'VALE', name: 'VALE'},
    {id: 'VIA', name: 'VIA'},
    {id: 'VIEW', name: 'VIEW'},
    {id: 'VILLGE', name: 'VILLGE'},
    {id: 'VISTA', name: 'VISTA'},
    {id: 'VOIE', name: 'VOIE'},
    {id: 'WALK', name: 'WALK'},
    {id: 'WAY', name: 'WAY'},
    {id: 'WHARF', name: 'WHARF'},
    {id: 'WOOD', name: 'WOOD'},
    {id: 'WYND', name: 'WYND'}
  ],

  ociProductType: [
    {id: '', name: ''},
    {id: '1st Mortgage', name: '1st Mortgage'},
    {id: '2nd Mortgage', name: '2nd Mortgage'}
  ],
  ociRateType: [
    {id: '', name: ''},
    {id: 'Fixed', name: 'Fixed'},
    {id: 'Variable', name: 'Variable'}
  ],
  ociTermType: [
    {id: '', name: ''},
    {id: 'Closed', name: 'Closed'},
    {id: 'Open', name: 'Open'}
  ],
  ociPurposeOfLoans: [
    {id: '', name: ''},
    {id: 'Purchase', name: 'Purchase'},
    {id: 'Refinance', name: 'Refinance'},
    {id: 'Purchase plus Improvements', name: 'Purchase plus Improvements'},
    {id: 'Deficiency Sale', name: 'Deficiency Sale'},
    {id: 'Work Out', name: 'Work Out'},
    {id: 'Port', name: 'Port'},
    {id: 'Switch/Transfer', name: 'Switch/Transfer'},
    {id: 'ETO', name: 'ETO'},
  ],
  ociCreditType: [
    {id: '', name: ''},
    {id: 'Credit Card', name: 'Credit Card'},
    {id: 'LOC', name: 'LOC'}
  ],
  ociPaymentFrequency: [
    {id: '', name: ''},
    {id: 'Monthly', name: 'Monthly'},
    {id: 'Semi-monthly', name: 'Semi-monthly'},
    {id: 'Weekly', name: 'Weekly'},
    {id: 'Bi-weekly', name: 'Bi-weekly'},
    {id: 'Acc-weekly', name: 'Acc-weekly'},
    {id: 'Acc-biweekly', name: 'Acc-biweekly'},
    {id: 'Annually', name: 'Annually'},
    {id: 'Semi-annually', name: 'Semi-annually'},
    {id: 'Quarterly', name: 'Quarterly'}
  ],
  ociMProductName: [
    {id: '', name: ''},
    {id: 'productA', name: 'product A'},
    {id: 'productB', name: 'product B'},
    {id: 'productC', name: 'product C'},
    {id: 'productD', name: 'product D'}
  ],
  ociMortgageType: [
    {id: '', name: ''},
    {id: 'First', name: 'First'},
    {id: 'Second', name: 'Second'},
    {id: 'Third', name: 'Third'}
  ],
  ociLiabilityType:[
    {id: '', name: ''},
    {id: 'Mortgage', name: 'Mortgage'},
    {id: 'LOC', name: 'LOC'},
  ],
  ociOffsetPercent: [
    {id: '', name: ''},
    {id: '0', name: '0'},
    {id: '0.1', name: '10'},
    {id: '0.2', name: '20'},
    {id: '0.3', name: '30'},
    {id: '0.4', name: '40'},
    {id: '0.5', name: '50'},
    {id: '0.6', name: '60'},
    {id: '0.7', name: '70'},
    {id: '0.8', name: '80'},
    {id: '0.9', name: '90'},
    {id: '1', name: '100'}
  ],
  ociRentalOffsetOption: [
    {id: '', name: ''},
    {id: 'true', name: 'Yes'},
    {id: 'false', name: 'No'}
  ],
  ociYesOrNo: [
    {id: '', name: ''},
    {id: 'true', name: 'Yes'},
    {id: 'false', name: 'No'}
  ],
  ociPaymentType: [
    {id: '', name: ''},
    {id: '3% of Balance', name: '3% of Balance'},
    {id: '3% of limit', name: '3% of limit'},
    {id: 'Add Payment', name: 'Add Payment'}
  ],
  ociPaymentTypeExistingProperty: [
    {id: '', name: ''},
    {id: 'Add Payment', name: 'Add Payment'} //TODO: confirm that this can be removed (no dependencies) then remove it
  ],
  ociAssetType: [
    {id: '', name: ''},
    {id: 'Pension', name: 'Pension'},
    {id: 'RESP', name: 'RESP'},
    {id: 'Chequing', name: 'Chequing'},
    {id: 'GIC', name: 'GIC'},
    {id: 'Savings', name: 'Savings'},
    {id: 'RIF', name: 'RIF'},
    {id: 'Vehicle', name: 'Vehicle'},
    {id: 'RSP', name: 'RSP'},
    {id: 'Stock', name: 'Stock'},
    {id: 'Mutual Funds', name: 'Mutual Funds'},
    {id: 'Shares', name: 'Shares'},
    {id: 'TFSA', name: 'TFSA'},
    {id: 'Deposit', name: 'Deposit'},
    {id: 'Other', name: 'Other'}
  ],
  ociGenericLiabilityType: [
    {id: '', name: ''},
    {id: 'Loan', name: 'Loan'},
    {id: 'Credit Card', name: 'Credit Card'},
    {id: 'LOC', name: 'LOC'},
    {id: 'Rent', name: 'Rent'},
    {id: 'Other', name: 'Other'}
  ],
  ociOtherIncomeType: [
    {id: '', name: ''},
    {id: 'Salary', name: 'Salary'},
    {id: 'Spouse', name: 'Spouse'},
    {id: 'Bonus', name: 'Bonus'},
    {id: 'Commission', name: 'Commission'},
    {id: 'Invest', name: 'Invest'},
    {id: 'Other', name: 'Other'}
  ],
  ociIncomeFrequency: [
    {id: '', name: ''},
    {id: 'Weekly', name: 'Weekly'},
    {id: 'Bi-weekly', name: 'Bi-Weekly'},
    {id: 'Semi-monthly', name: 'Semi-monthly'},
    {id: 'Monthly', name: 'Monthly'},
    {id: 'Annually', name: 'Annually'}
  ],
  ociEmploymentOccupation: [
    {id: '', name: ''},
    {id: 'Agricultural', name: 'AGRICULTURAL'},
    {id: 'At Home', name: 'AT HOME'},
    {id: 'Construction', name: 'CONSTRUCTION'},
    {id: 'Executive', name: 'EXECUTIVE'},
    {id: 'Information Technology', name: 'INFORMATION TECHNOLOGY'},
    {id: 'Labourer', name: 'LABOURER'},
    {id: 'Manager', name: 'MANAGER'},
    {id: 'Military', name: 'MILITARY'},
    {id: 'Office Staff', name: 'OFFICE STAFF'},
    {id: 'Production', name: 'PRODUCTION'},
    {id: 'Professional', name: 'PROFESSIONAL'},
    {id: 'Sales', name: 'SALES'},
    {id: 'Self-Employed', name: 'SELF-EMPLOYED'},
    {id: 'Service', name: 'SERVICE'},
    {id: 'Student', name: 'STUDENT'},
    {id: 'Trades', name: 'TRADES'},
    {id: 'Unemployed', name: 'UNEMPLOYED'},
    {id: 'Other', name: 'OTHER'},
  ],
  ociIncomeType: [
    {id: '', name: ''},
    {id: 'Salaried', name: 'Salaried'},
    {id: 'Seasonal', name: 'Seasonal'},
    {id: 'Self Employed', name: 'Self Employed'},
    {id: 'Pensioner', name: 'Pensioner'},
    {id: 'Alimony', name: 'Alimony'},
    {id: 'Other', name: 'Other'}
  ],
  ociEmploymentIndustry: [
    {id: '', name: ''},
    {id: 'Construction', name: 'Construction'},
    {id: 'Government', name: 'Government'},
    {id: 'Health', name: 'Health'},
    {id: 'Education', name: 'Education'},
    {id: 'Hi-Tech', name: 'Hi-Tech'},
    {id: 'Retail Sales', name: 'Retail Sales'},
    {id: 'Leisure/Entertainment', name: 'Leisure/Entertainment'},
    {id: 'Banking/Finance', name: 'Banking/Finance'},
    {id: 'Transport', name: 'Transport'},
    {id: 'Services', name: 'Services'},
    {id: 'Manufacturing', name: 'Manufacturing'},
    {id: 'Farming/Natural Resources', name: 'Farming/Natural Resources'},
    {id: 'Other', name: 'Other'},
  ],
  ociEmploymentType: [
    {id: '', name: ''},
    {id: 'Full Time', name: 'Full Time'},
    {id: 'Part Time', name: 'Part Time'},
    {id: 'Retired', name: 'Retired'},
    {id: 'Seasonal', name: 'Seasonal'},
    {id: 'Self-Employed', name: 'Self-Employed'},
    {id: 'Student', name: 'Student'},
    {id: 'Unemployed', name: 'Unemployed'},
    {id: 'Other', name: 'Other'},
  ],
  ociAddressStatus: [
    {id: '', name: ''},
    {id: 'Current', name: 'Current'},
    {id: 'Previous', name: 'Previous'}
  ],
  ociEmploymentStatus: [
    {id: '', name: ''},
    {id: 'Current', name: 'Current'},
    {id: 'Previous', name: 'Previous'}
  ],
  ociResidenceStatus: [
    {id: '', name: ''},
    {id: 'Rent', name: 'Rent'},
    {id: 'Own', name: 'Own'}
  ],
  ociProvinces: [
    {id: '', name: ''},
    {id: 'ON', name: 'ON'},
    {id: 'QC', name: 'QC'},
    {id: 'AB', name: 'AB'},
    {id: 'BC', name: 'BC'},
    {id: 'NL', name: 'NL'},
    {id: 'PE', name: 'PE'},
    {id: 'NS', name: 'NS'},
    {id: 'NB', name: 'NB'},
    {id: 'MB', name: 'MB'},
    {id: 'SK', name: 'SK'},
    {id: 'YT', name: 'YT'},
    {id: 'NT', name: 'NT'},
    {id: 'NU', name: 'NU'}

  ],
  ociStates: [
    {id: '', name: ''},
    {id: 'AK', name: 'AK'},
    {id: 'AL', name: 'AL'},
    {id: 'AR', name: 'AR'},
    {id: 'AZ', name: 'AZ'},
    {id: 'CA', name: 'CA'},
    {id: 'CO', name: 'CO'},
    {id: 'CT', name: 'CT'},
    {id: 'DC', name: 'DC'},
    {id: 'DE', name: 'DE'},
    {id: 'FL', name: 'FL'},
    {id: 'GA', name: 'GA'},
    {id: 'HI', name: 'HI'},
    {id: 'IA', name: 'IA'},
    {id: 'ID', name: 'ID'},
    {id: 'IL', name: 'IL'},
    {id: 'IN', name: 'IN'},
    {id: 'KS', name: 'KS'},
    {id: 'KY', name: 'KY'},
    {id: 'LA', name: 'LA'},
    {id: 'MA', name: 'MA'},
    {id: 'MD', name: 'MD'},
    {id: 'MI', name: 'MI'},
    {id: 'MN', name: 'MN'},
    {id: 'MO', name: 'MO'},
    {id: 'MS', name: 'MS'},
    {id: 'MT', name: 'MT'},
    {id: 'NC', name: 'NC'},
    {id: 'ND', name: 'ND'},
    {id: 'NE', name: 'NE'},
    {id: 'NH', name: 'NH'},
    {id: 'NJ', name: 'NJ'},
    {id: 'NM', name: 'NM'},
    {id: 'NV', name: 'NV'},
    {id: 'OA', name: 'OA'},
    {id: 'OH', name: 'OH'},
    {id: 'OK', name: 'OK'},
    {id: 'OR', name: 'OR'},
    {id: 'PA', name: 'PA'},
    {id: 'RI', name: 'RI'},
    {id: 'SC', name: 'SC'},
    {id: 'SD', name: 'SD'},
    {id: 'TN', name: 'TN'},
    {id: 'TX', name: 'TX'},
    {id: 'UT', name: 'UT'},
    {id: 'VA', name: 'VA'},
    {id: 'VT', name: 'VT'},
    {id: 'WA', name: 'WA'},
    {id: 'WI', name: 'WI'},
    {id: 'WV', name: 'WV'},
    {id: 'WY', name: 'WY'},
  ],
  ociGender: [
    {id: '', name: ''},
    {id: 'Male', name: 'Male'},
    {id: 'Female', name: 'Female'},
    {id: 'Other', name: 'Other'}
  ],
  ociMaritalStatus: [
    {id: '', name: ''},
    {id: 'Never Married', name: 'Never Married'},
    {id: 'Married', name: 'Married'},
    {id: 'Divorced', name: 'Divorced'},
    {id: 'Common Law', name: 'Common Law'},
    {id: 'Widowed', name: 'Widowed'},
    {id: 'Annulled', name: 'Annulled'},
    {id: 'Separated', name: 'Separated'},
  ],
  ociBanks:[
    {id: 'empty', name: ''},
    {id: 'no', name: 'No pre-auth'},
    {id: 'none', name: 'Not On List'},
    {id: 'CIBC', name: 'CIBC'},
    {id: 'RBC', name: 'RBC'},
    {id: 'TD', name: 'TD'},
    {id: 'BMO', name: 'BMO'},
    {id: 'DUCA', name: 'DUCA'},
    {id: 'SCOTIA', name: 'SCOTIA BANK'},
  ],
  ociCountries:
    [{id: '', name: ''},
      {id: 'CANADA', name: 'CANADA'},
      {id: 'USA', name: 'USA'},
      {id: 'AFGHANISTAN', name: 'AFGHANISTAN'},
      {id: 'ANTARCTICA', name: 'ANTARCTICA'},
      {id: 'ALBANIA', name: 'ALBANIA'},
      {id: 'ALGERIA', name: 'ALGERIA'},
      {id: 'AMERICAN SAMOA', name: 'AMERICAN SAMOA'},
      {id: 'ANDORRA', name: 'ANDORRA'},
      {id: 'ANGOLA', name: 'ANGOLA'},
      {id: 'ANTIGUA AND BARBUDA', name: 'ANTIGUA AND BARBUDA'},
      {id: 'AZERBAIJAN', name: 'AZERBAIJAN'},
      {id: 'ARGENTINA', name: 'ARGENTINA'},
      {id: 'AUSTRALIA', name: 'AUSTRALIA'},
      {id: 'YUGOSLAVIA', name: 'YUGOSLAVIA'},
      {id: 'BAHRAIN', name: 'BAHRAIN'},
      {id: 'BANGLADESH', name: 'BANGLADESH'},
      {id: 'ARMENIA', name: 'ARMENIA'},
      {id: 'BARBADOS', name: 'BARBADOS'},
      {id: 'BELGIUM', name: 'BELGIUM'},
      {id: 'BERMUDA', name: 'BERMUDA'},
      {id: 'BHUTAN', name: 'BHUTAN'},
      {id: 'BOLIVIA', name: 'BOLIVIA'},
      {id: 'BOSNIA AND HERZEGOWINA', name: 'BOSNIA AND HERZEGOWINA'},
      {id: 'BOTSWANA', name: 'BOTSWANA'},
      {id: 'BOUVET ISLAND', name: 'BOUVET ISLAND'},
      {id: 'BRAZIL', name: 'BRAZIL'},
      {id: 'BELIZE', name: 'BELIZE'},
      {id: 'BRITISH INDIAN OCEAN TERRITORY', name: 'BRITISH INDIAN OCEAN TERRITORY'},
      {id: 'SOLOMON ISLANDS', name: 'SOLOMON ISLANDS'},
      {id: 'VIRGIN ISLANDS (BRITISH)', name: 'VIRGIN ISLANDS (BRITISH)'},
      {id: 'BRUNEI DARUSSALAM', name: 'BRUNEI DARUSSALAM'},
      {id: 'BULGARIA', name: 'BULGARIA'},
      {id: 'BURUNDI', name: 'BURUNDI'},
      {id: 'BELARUS', name: 'BELARUS'},
      {id: 'CAMBODIA', name: 'CAMBODIA'},
      {id: 'CAMEROON', name: 'CAMEROON'},
      {id: 'CAPE VERDE', name: 'CAPE VERDE'},
      {id: 'CAYMAN ISLANDS', name: 'CAYMAN ISLANDS'},
      {id: 'CENTRAL AFRICAN REPUBLIC', name: 'CENTRAL AFRICAN REPUBLIC'},
      {id: 'SRI LANKA', name: 'SRI LANKA'},
      {id: 'CHAD', name: 'CHAD'},
      {id: 'CHILE', name: 'CHILE'},
      {id: 'CHINA', name: 'CHINA'},
      {id: 'TAIWAN', name: 'TAIWAN'},
      {id: 'CHRISTMAS ISLAND', name: 'CHRISTMAS ISLAND'},
      {id: 'COCOS (KEELING) ISLANDS', name: 'COCOS (KEELING) ISLANDS'},
      {id: 'COLOMBIA', name: 'COLOMBIA'},
      {id: 'COMOROS', name: 'COMOROS'},
      {id: 'MAYOTTE', name: 'MAYOTTE'},
      {id: 'CONGO, Republic of', name: 'CONGO, Republic of'},
      {id: 'CONGO, Democratic Republic of (was Zaire)', name: 'CONGO, Democratic Republic of (was Zaire)'},
      {id: 'COOK ISLANDS', name: 'COOK ISLANDS'},
      {id: 'COSTA RICA', name: 'COSTA RICA'},
      {id: 'CROATIA (local name: Hrvatska)', name: 'CROATIA (local name: Hrvatska)'},
      {id: 'CUBA', name: 'CUBA'},
      {id: 'CYPRUS', name: 'CYPRUS'},
      {id: 'CZECH REPUBLIC', name: 'CZECH REPUBLIC'},
      {id: 'BENIN', name: 'BENIN'},
      {id: 'DENMARK', name: 'DENMARK'},
      {id: 'DOMINICA', name: 'DOMINICA'},
      {id: 'DOMINICAN REPUBLIC', name: 'DOMINICAN REPUBLIC'},
      {id: 'ECUADOR', name: 'ECUADOR'},
      {id: 'EL SALVADOR', name: 'EL SALVADOR'},
      {id: 'EQUATORIAL GUINEA', name: 'EQUATORIAL GUINEA'},
      {id: 'ETHIOPIA', name: 'ETHIOPIA'},
      {id: 'ERITREA', name: 'ERITREA'},
      {id: 'ESTONIA', name: 'ESTONIA'},
      {id: 'FAROE ISLANDS', name: 'FAROE ISLANDS'},
      {id: 'FALKLAND ISLANDS (MALVINAS)', name: 'FALKLAND ISLANDS (MALVINAS)'},
      {id: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS', name: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'},
      {id: 'FIJI', name: 'FIJI'},
      {id: 'FINLAND', name: 'FINLAND'},
      {id: 'AALAND ISLANDS', name: 'AALAND ISLANDS'},
      {id: 'FRANCE', name: 'FRANCE'},
      {id: 'FRENCH GUIANA', name: 'FRENCH GUIANA'},
      {id: 'FRENCH POLYNESIA', name: 'FRENCH POLYNESIA'},
      {id: 'FRENCH SOUTHERN TERRITORIES', name: 'FRENCH SOUTHERN TERRITORIES'},
      {id: 'DJIBOUTI', name: 'DJIBOUTI'},
      {id: 'GABON', name: 'GABON'},
      {id: 'GEORGIA', name: 'GEORGIA'},
      {id: 'GAMBIA', name: 'GAMBIA'},
      {id: 'PALESTINIAN TERRITORY, Occupied', name: 'PALESTINIAN TERRITORY, Occupied'},
      {id: 'GERMANY', name: 'GERMANY'},
      {id: 'GHANA', name: 'GHANA'},
      {id: 'GIBRALTAR', name: 'GIBRALTAR'},
      {id: 'KIRIBATI', name: 'KIRIBATI'},
      {id: 'GREECE', name: 'GREECE'},
      {id: 'GREENLAND', name: 'GREENLAND'},
      {id: 'GRENADA', name: 'GRENADA'},
      {id: 'GUADELOUPE', name: 'GUADELOUPE'},
      {id: 'GUAM', name: 'GUAM'},
      {id: 'GUATEMALA', name: 'GUATEMALA'},
      {id: 'GUINEA', name: 'GUINEA'},
      {id: 'GUYANA', name: 'GUYANA'},
      {id: 'HAITI', name: 'HAITI'},
      {id: 'HEARD AND MC DONALD ISLANDS', name: 'HEARD AND MC DONALD ISLANDS'},
      {id: 'VATICAN CITY STATE (HOLY SEE)', name: 'VATICAN CITY STATE (HOLY SEE)'},
      {id: 'HONDURAS', name: 'HONDURAS'},
      {id: 'HONG KONG', name: 'HONG KONG'},
      {id: 'HUNGARY', name: 'HUNGARY'},
      {id: 'ICELAND', name: 'ICELAND'},
      {id: 'INDIA', name: 'INDIA'},
      {id: 'INDONESIA', name: 'INDONESIA'},
      {id: 'IRAN (ISLAMIC REPUBLIC OF)', name: 'IRAN (ISLAMIC REPUBLIC OF)'},
      {id: 'IRAQ', name: 'IRAQ'},
      {id: 'IRELAND', name: 'IRELAND'},
      {id: 'ISRAEL', name: 'ISRAEL'},
      {id: 'ITALY', name: 'ITALY'},
      {id: 'COTE DIVOIRE', name: 'COTE DIVOIRE'},
      {id: 'JAMAICA', name: 'JAMAICA'},
      {id: 'JAPAN', name: 'JAPAN'},
      {id: 'KAZAKHSTAN', name: 'KAZAKHSTAN'},
      {id: 'JORDAN', name: 'JORDAN'},
      {id: 'KENYA', name: 'KENYA'},
      {id: 'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF', name: 'KOREA, DEMOCRATIC PEOPLES REPUBLIC OF'},
      {id: 'KOREA, REPUBLIC OF', name: 'KOREA, REPUBLIC OF'},
      {id: 'KUWAIT', name: 'KUWAIT'},
      {id: 'KYRGYZSTAN', name: 'KYRGYZSTAN'},
      {id: 'LAO PEOPLES DEMOCRATIC REPUBLIC', name: 'LAO PEOPLES DEMOCRATIC REPUBLIC'},
      {id: 'LEBANON', name: 'LEBANON'},
      {id: 'LESOTHO', name: 'LESOTHO'},
      {id: 'LATVIA', name: 'LATVIA'},
      {id: 'LIBERIA', name: 'LIBERIA'},
      {id: 'LIBYAN ARAB JAMAHIRIYA', name: 'LIBYAN ARAB JAMAHIRIYA'},
      {id: 'LIECHTENSTEIN', name: 'LIECHTENSTEIN'},
      {id: 'LITHUANIA', name: 'LITHUANIA'},
      {id: 'LUXEMBOURG', name: 'LUXEMBOURG'},
      {id: 'MACAU', name: 'MACAU'},
      {id: 'MADAGASCAR', name: 'MADAGASCAR'},
      {id: 'MALAWI', name: 'MALAWI'},
      {id: 'MALAYSIA', name: 'MALAYSIA'},
      {id: 'MALDIVES', name: 'MALDIVES'},
      {id: 'MALI', name: 'MALI'},
      {id: 'MALTA', name: 'MALTA'},
      {id: 'MARTINIQUE', name: 'MARTINIQUE'},
      {id: 'MAURITANIA', name: 'MAURITANIA'},
      {id: 'MAURITIUS', name: 'MAURITIUS'},
      {id: 'MEXICO', name: 'MEXICO'},
      {id: 'MONACO', name: 'MONACO'},
      {id: 'MONGOLIA', name: 'MONGOLIA'},
      {id: 'MOLDOVA, REPUBLIC OF', name: 'MOLDOVA, REPUBLIC OF'},
      {id: 'MONTSERRAT', name: 'MONTSERRAT'},
      {id: 'MOROCCO', name: 'MOROCCO'},
      {id: 'MOZAMBIQUE', name: 'MOZAMBIQUE'},
      {id: 'OMAN', name: 'OMAN'},
      {id: 'NAMIBIA', name: 'NAMIBIA'},
      {id: 'NAURU', name: 'NAURU'},
      {id: 'NEPAL', name: 'NEPAL'},
      {id: 'NETHERLANDS', name: 'NETHERLANDS'},
      {id: 'NETHERLANDS ANTILLES', name: 'NETHERLANDS ANTILLES'},
      {id: 'ARUBA', name: 'ARUBA'},
      {id: 'NEW CALEDONIA', name: 'NEW CALEDONIA'},
      {id: 'VANUATU', name: 'VANUATU'},
      {id: 'NEW ZEALAND', name: 'NEW ZEALAND'},
      {id: 'NICARAGUA', name: 'NICARAGUA'},
      {id: 'NIGER', name: 'NIGER'},
      {id: 'NIGERIA', name: 'NIGERIA'},
      {id: 'NIUE', name: 'NIUE'},
      {id: 'NORFOLK ISLAND', name: 'NORFOLK ISLAND'},
      {id: 'NORWAY', name: 'NORWAY'},
      {id: 'NORTHERN MARIANA ISLANDS', name: 'NORTHERN MARIANA ISLANDS'},
      {id: 'UNITED STATES MINOR OUTLYING ISLANDS', name: 'UNITED STATES MINOR OUTLYING ISLANDS'},
      {id: 'MICRONESIA, FEDERATED STATES OF', name: 'MICRONESIA, FEDERATED STATES OF'},
      {id: 'MARSHALL ISLANDS', name: 'MARSHALL ISLANDS'},
      {id: 'PALAU', name: 'PALAU'},
      {id: 'PAKISTAN', name: 'PAKISTAN'},
      {id: 'PANAMA', name: 'PANAMA'},
      {id: 'PAPUA NEW GUINEA', name: 'PAPUA NEW GUINEA'},
      {id: 'PARAGUAY', name: 'PARAGUAY'},
      {id: 'PERU', name: 'PERU'},
      {id: 'PHILIPPINES', name: 'PHILIPPINES'},
      {id: 'PITCAIRN', name: 'PITCAIRN'},
      {id: 'POLAND', name: 'POLAND'},
      {id: 'PORTUGAL', name: 'PORTUGAL'},
      {id: 'GUINEA-BISSAU', name: 'GUINEA-BISSAU'},
      {id: 'TIMOR-LESTE', name: 'TIMOR-LESTE'},
      {id: 'PUERTO RICO', name: 'PUERTO RICO'},
      {id: 'QATAR', name: 'QATAR'},
      {id: 'REUNION', name: 'REUNION'},
      {id: 'ROMANIA', name: 'ROMANIA'},
      {id: 'RUSSIAN FEDERATION', name: 'RUSSIAN FEDERATION'},
      {id: 'RWANDA', name: 'RWANDA'},
      {id: 'SAINT HELENA', name: 'SAINT HELENA'},
      {id: 'SAINT KITTS AND NEVIS', name: 'SAINT KITTS AND NEVIS'},
      {id: 'ANGUILLA', name: 'ANGUILLA'},
      {id: 'SAINT LUCIA', name: 'SAINT LUCIA'},
      {id: 'SAINT PIERRE AND MIQUELON', name: 'SAINT PIERRE AND MIQUELON'},
      {id: 'SAINT VINCENT AND THE GRENADINES', name: 'SAINT VINCENT AND THE GRENADINES'},
      {id: 'SAN MARINO', name: 'SAN MARINO'},
      {id: 'SAO TOME AND PRINCIPE', name: 'SAO TOME AND PRINCIPE'},
      {id: 'SAUDI ARABIA', name: 'SAUDI ARABIA'},
      {id: 'SENEGAL', name: 'SENEGAL'},
      {id: 'SEYCHELLES', name: 'SEYCHELLES'},
      {id: 'SIERRA LEONE', name: 'SIERRA LEONE'},
      {id: 'SINGAPORE', name: 'SINGAPORE'},
      {id: 'SLOVAKIA', name: 'SLOVAKIA'},
      {id: 'VIET NAM', name: 'VIET NAM'},
      {id: 'SLOVENIA', name: 'SLOVENIA'},
      {id: 'SOMALIA', name: 'SOMALIA'},
      {id: 'SOUTH AFRICA', name: 'SOUTH AFRICA'},
      {id: 'ZIMBABWE', name: 'ZIMBABWE'},
      {id: 'SPAIN', name: 'SPAIN'},
      {id: 'WESTERN SAHARA', name: 'WESTERN SAHARA'},
      {id: 'SUDAN', name: 'SUDAN'},
      {id: 'SURIname', name: 'SURIname'},
      {id: 'SVALBARD AND JAN MAYEN ISLANDS', name: 'SVALBARD AND JAN MAYEN ISLANDS'},
      {id: 'SWAZILAND', name: 'SWAZILAND'},
      {id: 'SWEDEN', name: 'SWEDEN'},
      {id: 'SWITZERLAND', name: 'SWITZERLAND'},
      {id: 'SYRIAN ARAB REPUBLIC', name: 'SYRIAN ARAB REPUBLIC'},
      {id: 'TAJIKISTAN', name: 'TAJIKISTAN'},
      {id: 'THAILAND', name: 'THAILAND'},
      {id: 'TOGO', name: 'TOGO'},
      {id: 'TOKELAU', name: 'TOKELAU'},
      {id: 'TONGA', name: 'TONGA'},
      {id: 'TRINIDAD AND TOBAGO', name: 'TRINIDAD AND TOBAGO'},
      {id: 'UNITED ARAB EMIRATES', name: 'UNITED ARAB EMIRATES'},
      {id: 'TUNISIA', name: 'TUNISIA'},
      {id: 'TURKEY', name: 'TURKEY'},
      {id: 'TURKMENISTAN', name: 'TURKMENISTAN'},
      {id: 'TUVALU', name: 'TUVALU'},
      {id: 'UGANDA', name: 'UGANDA'},
      {id: 'UKRAINE', name: 'UKRAINE'},
      {id: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF', name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'},
      {id: 'EGYPT', name: 'EGYPT'},
      {id: 'UNITED KINGDOM', name: 'UNITED KINGDOM'},
      {id: 'TANZANIA, UNITED REPUBLIC OF', name: 'TANZANIA, UNITED REPUBLIC OF'},
      {id: 'UNITED STATES', name: 'UNITED STATES'},
      {id: 'VIRGIN ISLANDS (U.S.)', name: 'VIRGIN ISLANDS (U.S.)'},
      {id: 'BURKINA FASO', name: 'BURKINA FASO'},
      {id: 'URUGUAY', name: 'URUGUAY'},
      {id: 'UZBEKISTAN', name: 'UZBEKISTAN'},
      {id: 'VENEZUELA', name: 'VENEZUELA'},
      {id: 'WALLIS AND FUTUNA ISLANDS', name: 'WALLIS AND FUTUNA ISLANDS'},
      {id: 'SAMOA', name: 'SAMOA'},
      {id: 'YEMEN', name: 'YEMEN'},
      {id: 'SERBIA AND MONTENEGRO', name: 'SERBIA AND MONTENEGRO'},
      {id: 'ZAMBIA', name: 'ZAMBIA'}
    ],
  personStatus: [
    {id: '', name: ''},
    {id: 'active', name: 'Active'},
    {id: 'inactive', name: 'Inactive'}
  ],
  // firmStatus = 'New' is a way for us to distinguish between an Active firm with ongoing projects, and a newly setup
  // but never used Firm..  this will help filter large dropdown lists for the analytics and performance screens.
  firmStatus: [
    {id: '', name: ''},
    {id: 'New', name: 'New'},
    {id: 'Active', name: 'Active'},
    {id: 'Inactive', name: 'Inactive'}
  ],
  timezone: [
    {id: '', name: ''},
    {id: 'EST', name: 'EST'}
  ],
  namePrefix: [
    {id: '', name: ''},
    {id: 'Ms', name: 'Ms'},
    {id: 'Miss', name: 'Miss'},
    {id: 'Mrs', name: 'Mrs'},
    {id: 'Mr', name: 'Mr'},
    {id: 'Master', name: 'Master'},
    {id: 'Fr', name: 'Father'},
    {id: 'Rev', name: 'Rev'},
    {id: 'Dr', name: 'Doctor'},
    {id: 'Atty', name: 'Attorney'},
    {id: 'Hon', name: 'Honorable'},
    {id: 'Prof', name: 'Professor'},
    {id: 'Pres', name: 'President'},
    {id: 'VP', name: 'Vice President'},
    {id: 'Gov', name: 'Governor'},
    {id: 'Ofc', name: 'Officer'}
  ],
  nameSuffix: [
    {id: '', name: ''},
    {id: 'Jr', name: 'Junior'},
    {id: 'Sr', name: 'Senior'},
    {id: '2nd', name: '2nd'},
    {id: '3rd', name: '3rd'},
    {id: 'II', name: 'II'},
    {id: 'III', name: 'III'},
    {id: 'Esq', name: 'Esquire'},
    {id: 'CPA', name: 'CPA'},
    {id: 'DC', name: 'DC'},
    {id: 'DDS', name: 'DDS'},
    {id: 'VM', name: 'VM'},
    {id: 'JD', name: 'JD'},
    {id: 'MD', name: 'MD'},
    {id: 'PhD', name: 'Phd'}
  ],
  phoneType: [
    {id: '', name: ''},
    {id: 'cell', name: 'Mobile'},
    {id: 'home', name: 'Home'},
    {id: 'work', name: 'Work'}
  ],
  firmGroup: [
    {id: '', name: ''},
    {id: 'sales', name: 'Sales'},
    {id: 'marketing', name: 'Marketing'},
    {id: 'management', name: 'Management'},
    {id: 'accounts', name: 'Accounting'}
  ],
  firmType: [
    {id: '', name: ''},
    {id: 'oci', name: 'OneClose'},
    {id: 'lender', name: 'Lender'},
    {id: 'developer', name: 'Developer'},
    {id: 'legal-closing', name: 'Closing Lawyer'},
  ],
  ociPurchaserEntryPath: [
    {id: '', name: ''},
    {id: 'purchaser/TermsOfService', name: 'purchaser/TermsOfService'},
  ],
  brokerageRepresenting: [
    {id: '', name: ''},
    {id: 'Borrower', name: 'The Borrower, not the Lender'},
    {id: 'Lender', name: 'The Lender, not the Borrower'},
    {id: 'Borrower-Lender', name: 'The Borrower & the Lender, not to the preference of either'}
  ],
  ociHoldCo:[
    {id: null, name: ""},
    {id: true, name: "Yes"},
    {id: false, name: "No"},
    ],
}
